"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "pb-2.5 font-bold em88:first:pt-2.5" };
const _hoisted_2 = { class: "mb-4 border-b border-b-gray-40 pb-3 last:mb-0 last:border-b-0 last:pb-0" };
const _hoisted_3 = { class: "pb-2.5 font-bold em88:first:pt-2.5" };
const _hoisted_4 = { class: "mb-4 border-b border-b-gray-40 pb-3 last:mb-0 last:border-b-0 last:pb-0" };
const _hoisted_5 = { class: "pb-2.5 font-bold em88:first:pt-2.5" };
const vue_i18n_1 = require("vue-i18n");
const use_findings_1 = __importDefault(require("@/SearchApp/composables/use-findings"));
const use_search_1 = __importStar(require("@/SearchApp/composables/use-search"));
const TypeAheadItem_vue_1 = __importDefault(require("./TypeAheadItem.vue"));
const use_department_1 = __importDefault(require("@/SearchApp/composables/use-department"));
const ocm_object_1 = require("@ocm/services/ocm-object");
const dataLayer_1 = require("@/SearchApp/services/dataLayer");
exports.default = (0, vue_1.defineComponent)({
    __name: 'FindingsShop',
    setup(__props) {
        const { t } = (0, vue_i18n_1.useI18n)();
        const { findings } = (0, use_findings_1.default)();
        const { resetSearch } = (0, use_search_1.default)();
        const { departmentCapitalized, department } = (0, use_department_1.default)();
        const generateSearchUrl = (term) => `${ocm_object_1.contextPath}/suche/?s=${encodeURIComponent(term)}&department=${department.value}#/Kategorie/${departmentCapitalized.value}`;
        const routeToSearchResults = (event) => {
            window.ocmOrchestrator && window.ocmOrchestrator.spaNavigateUrl(event);
        };
        const onClick = (term, event) => {
            (0, dataLayer_1.tr_searchEvent)({ searchterm: term, type: "typeahead" });
            routeToSearchResults(event);
            resetSearch();
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                ((0, vue_2.unref)(findings).brands.length > 0)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, [
                        (0, vue_2.createElementVNode)("div", _hoisted_1, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)("siteWide.searchApp.findings.brand")), 1),
                        (0, vue_2.createElementVNode)("div", _hoisted_2, [
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(findings).brands, (item, index) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(TypeAheadItem_vue_1.default, {
                                    key: index,
                                    "item-text": item,
                                    "is-active": index === (0, vue_2.unref)(use_search_1.focusedTypeAheadIndex),
                                    href: generateSearchUrl(item),
                                    onClick: ($event) => (onClick(item, $event))
                                }, null, 8, ["item-text", "is-active", "href", "onClick"]));
                            }), 128))
                        ])
                    ], 64))
                    : (0, vue_2.createCommentVNode)("", true),
                ((0, vue_2.unref)(findings).categories.length > 0)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 1 }, [
                        (0, vue_2.createElementVNode)("div", _hoisted_3, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)("siteWide.searchApp.findings.categories")), 1),
                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(findings).categories, (item, index) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(TypeAheadItem_vue_1.default, {
                                    key: index,
                                    "item-text": item,
                                    "is-active": index + (0, vue_2.unref)(findings).brands.length === (0, vue_2.unref)(use_search_1.focusedTypeAheadIndex),
                                    href: generateSearchUrl(item),
                                    onClick: ($event) => (onClick(item, $event))
                                }, null, 8, ["item-text", "is-active", "href", "onClick"]));
                            }), 128))
                        ])
                    ], 64))
                    : (0, vue_2.createCommentVNode)("", true),
                ((0, vue_2.unref)(findings).others.length > 0)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 2 }, [
                        (0, vue_2.createElementVNode)("div", _hoisted_5, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)("siteWide.searchApp.findings.moreSuggestions")), 1),
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(findings).others, (item, index) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(TypeAheadItem_vue_1.default, {
                                key: index,
                                "item-text": item,
                                "is-active": index + (0, vue_2.unref)(findings).brands.length + (0, vue_2.unref)(findings).categories.length === (0, vue_2.unref)(use_search_1.focusedTypeAheadIndex),
                                href: generateSearchUrl(item),
                                onClick: ($event) => (onClick(item, $event))
                            }, null, 8, ["item-text", "is-active", "href", "onClick"]));
                        }), 128))
                    ], 64))
                    : (0, vue_2.createCommentVNode)("", true)
            ], 64));
        };
    }
});
